'use strict';

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/**
 * Wogaa Layer Helper
 */
var WogaaLayerHelper = /*#__PURE__*/function () {
  /**
   * Constructor will register
   * @param wogaaLayer []
   * @param callback Function
   * @param options Object
   */
  function WogaaLayerHelper(wogaaLayer, callback, options) {
    var _this = this;
    _classCallCheck(this, WogaaLayerHelper);
    /**
     * The Wogaa Layer with all the events
     * @type Array
     * @private
     */
    this._wogaaLayer = wogaaLayer;

    /**
     * The callback that triggers when 'push' called
     * @type Function
     * @private
     */
    this._callback = callback || function () {};

    /**
     * The internal queue of wogaaLayer updates that have not yet been processed.
     * @type {Array}
     * @private
     */
    this._unprocessed = [];

    /**
     * The internal marker for checking if the listener is currently on the stack.
     * @type {boolean}
     * @private
     */
    this._executingListener = false;

    /**
     * The internal representation of the dataLayer's state at the time of the
     * update currently being processed.
     * @type {!Object}
     * @private
     */
    this._model = {};

    /**
     * The internal options object
     * @type {Object}
     * @private
     */
    this._options = _objectSpread2({
      skipOldValues: false
    }, options);

    // Process the existing/past states.
    this._processStates(this._wogaaLayer, this._options.skipOldValues);

    // Add listener for future state changes.
    var oldPush = this._wogaaLayer.push;
    this._wogaaLayer.push = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var states = [].slice.call(args, 0);
      states = states.map(function (obj) {
        return _objectSpread2(_objectSpread2({}, obj), {}, {
          'wogaa.time': new Date().getTime()
        });
      });
      var result = oldPush.apply(_this._wogaaLayer, states);
      _this._processStates(states, false);
      return result;
    };
  }

  /**
   * Process states
   * @param states
   * @param skipOldValues
   * @private
   */
  _createClass(WogaaLayerHelper, [{
    key: "_processStates",
    value: function _processStates(states, skipOldValues) {
      this._unprocessed.push.apply(this._unprocessed, states);
      while (this._executingListener === false && this._unprocessed.length > 0) {
        var update = this._unprocessed.shift();

        // TODO we need to prevent arrays, functions, stupid objects merging here.
        // This model is will merge every valid property so subscribers can listen to them.
        this._model = _objectSpread2(_objectSpread2({}, update), this._model);
        if (!skipOldValues) {
          this._executingListener = true;
          this._callback(this._model, update);
          this._executingListener = false;
        }
      }
    }

    /**
     * Get the value of an object at a specific
     * path, and let’s you optionally return a default
     * value if one isn’t found.
     * @param path
     * @param defaultValue
     * @returns {Object|*|*}
     */
  }, {
    key: "get",
    value: function get(path, defaultValue) {
      /**
       * If the path is a string, convert it to an array
       * @param  {String|Array} path The path
       * @return {Array}             The path array
       */
      var stringToPath = function stringToPath(path) {
        // If the path isn't a string, return it
        if (typeof path !== 'string') return path;
        // Create new array
        var output = [];

        // Split to an array with dot notation
        path.split('.').forEach(function (item) {
          // Split to an array with bracket notation
          item.split(/\[([^}]+)\]/g).forEach(function (key) {
            // Push to the new array
            if (key.length > 0) {
              output.push(key);
            }
          });
        });
        return output;
      };
      if (path) {
        // Get the path as an array
        path = stringToPath(path);
        // Cache the current object
        var current = this._model;
        // For each item in the path, dig into the object
        for (var i = 0; i < path.length; i++) {
          // If the item isn't found, return the default (or null)
          if (!current[path[i]]) return defaultValue;
          // Otherwise, update the current  value
          current = current[path[i]];
        }
        return current;
      } else {
        return this._model;
      }
    }
  }]);
  return WogaaLayerHelper;
}();
var src = WogaaLayerHelper;

module.exports = src;
